import { Getters } from './types';
import { getBalance, getBalanceWithBonus, getBonus } from '@models/user/UserDataService';

export const DEFAULT_USER_BALANCE = '-';

export const getters = {
    userBalance: (state) => {
        return state.user ? getBalance(state.user) : DEFAULT_USER_BALANCE;
    },
    /**
     * User sport balance used by web
     * @param _state authentication state
     */
    sportBonusBalance: (_state: any) => {
        return 0;
    },
    userBonus: (state) => {
        return state.user ? getBonus(state.user) : null;
    },
    userBalanceWithBonus: (state) => {
        return state.user ? getBalanceWithBonus(state.user) : null;
    },
} as {
    userBalance: Getters['userBalance'];
    userBonus: Getters['userBonus'];
    userBalanceWithBonus: Getters['userBalanceWithBonus'];
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/authentication/account.ts